import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import { useTranslation } from 'react-i18next';

const Index = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
      
      {/* Footer */}
      <footer className="py-8 px-6 border-t border-surface-variant">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-muted-foreground">
            {t('footer.copyright')}
          </p>
          <div className="mt-4">
            <a 
              href="/admin/login" 
              className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors"
            >
              {t('footer.admin')}
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
